import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { _ } from '@mira-avant/mtlibs';

let hasActivated = false;

export const watchForActivityTokenRefreshGuard: CanActivateFn = (route, state) => {
	if (hasActivated) {
		return true;
	}

	hasActivated = true;

	const authService = inject(AuthService);

	authService.bindRefreshEvents(document.body as HTMLElement);

	return true;
};
